import { EventAuditEnum } from '~/shared/config/enums'

export const eventEnumLabels: Record<EventAuditEnum, string> = {
  [EventAuditEnum.CREATED]: 'Создание',
  [EventAuditEnum.UPDATED]: 'Редактирование',
  [EventAuditEnum.DELETED]: 'Удаление',
  [EventAuditEnum.RESTORED]: 'Восстановление',
}
